import React from "react";
import Loader from "./Loader.js";

class Button extends React.Component {
  constructor(props) {
    super(props);
    this.clickButton = this.clickButton.bind(this);
  }

  clickButton(e) {
    const { onClick } = this.props;
    if (onClick) {
      onClick(e);
    }
  }

  render() {
    const { className = "", children, loading, disabled } = this.props;
    return (
      <div className="overflow-hidden">
        <button type="submit" className={"btn btn-block " + className + (loading || disabled ? " disabled" : "")}>
          <div
            ref={(btn) => {
              this.btn = btn;
            }}
            onClick={!loading && !disabled ? this.clickButton : null}
            style={{ width: "100%" }}
          >
            <div className="button-content">{children}</div>
          </div>
        </button>
        {loading && <Loader />}
      </div>
    );
  }
}

export default Button;
